(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
if(!customElements.get('uc-footer-navigation')){
customElements.define('uc-footer-navigation',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
this.media=matchMedia('(min-width:750px)');
this.sync=()=>this.querySelectorAll('details').forEach(d=>d.open=this.media.matches);
this.sync();this.media.addEventListener('change',this.sync);
this.querySelectorAll('summary').forEach(s=>s.addEventListener('click',e=>{if(this.media.matches)e.preventDefault();}));
}
disconnectedCallback(){if(this.media)this.media.removeEventListener('change',this.sync);this.initialized=false;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.ucnav__group[open], .uc-mobile-menu[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('.ucnav__group[open], .uc-mobile-menu[open]')];
    const focused = open.filter(detail => detail.contains(document.activeElement)).pop();
    if (focused) { focused.removeAttribute('open'); focused.querySelector('summary').focus(); }
    else open.forEach(detail => detail.removeAttribute('open'));
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-chemical-catalog"]) return;
  try {
    
if (!customElements.get('uc-chemical-catalog')) {
  customElements.define('uc-chemical-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.category = 'all';
      this.cards = [...this.querySelectorAll('[data-category]')];
      this.input = this.querySelector('input[type=search]');
      this.querySelectorAll('[data-controls]').forEach(el => el.hidden = false);
      this.input.addEventListener('input', () => this.filter());
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        this.filter();
      }));
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.input.value = '';
        this.querySelector('[data-filter=all]').click();
        this.input.focus();
      });
      this.filter();
    }
    filter() {
      const terms = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matches = (this.category === 'all' || card.dataset.category.split(',').includes(this.category)) && terms.every(term => card.dataset.search.toLocaleLowerCase().includes(term));
        card.hidden = !matches;
        if (matches) count++;
      });
      const status = this.querySelector('[data-count]');
      status.textContent = status.dataset.template.replace('[count]', String(count));
      this.querySelector('.ucc__empty').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-happy-clients"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uc-happy-clients')){
customElements.define('uc-happy-clients',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const input=this.querySelector('input');const cards=[...this.querySelectorAll('[data-client]')];
this.querySelector('[data-controls]').hidden=false;
input.addEventListener('input',()=>{
const term=input.value.trim().toLocaleLowerCase();let count=0;
cards.forEach(card=>{card.hidden=!card.dataset.name.toLocaleLowerCase().includes(term);if(!card.hidden)count++;});
this.querySelector('[data-empty]').hidden=count>0;
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-merchandise"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uc-merchandise')){
customElements.define('uc-merchandise',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const panel=this.querySelector('[data-filters]'),buttons=[...panel.querySelectorAll('button')],cards=[...this.querySelectorAll('[data-merch-card]')],empty=this.querySelector('[data-empty]');
panel.hidden=cards.length===0;
buttons.forEach(button=>button.addEventListener('click',()=>{
const category=button.dataset.category;let count=0;
buttons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
cards.forEach(card=>{card.hidden=category!=='all'&&card.dataset.kind!==category;if(!card.hidden)count++;});
empty.hidden=count>0;
}));
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-price-list"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uc-price-list')){
  customElements.define('uc-price-list',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      const search=this.querySelector('input[type="search"]');
      const filter=this.querySelector('select');
      const products=[...this.querySelectorAll('[data-product]')];
      const update=()=>{
        const term=search.value.trim().toLocaleLowerCase();
        let visible=0;
        products.forEach(product=>{
          product.hidden=!product.dataset.search.toLocaleLowerCase().includes(term)||(filter.value==='chemicals'&&product.dataset.chemical!=='true');
          if(!product.hidden)visible++;
        });
        this.querySelector('[data-empty]').hidden=visible!==0;
      };
      this.querySelector('[data-controls]').hidden=false;
      search.addEventListener('input',update);
      filter.addEventListener('change',update);
      this.querySelector('[data-print]').addEventListener('click',()=>{
        const visible=new Set(products.filter(product=>!product.hidden).map(product=>product.querySelector('h2 a').getAttribute('href').split('/').pop()));
        this.querySelectorAll('[data-print-product]').forEach(row=>{row.hidden=!visible.has(row.dataset.handle);});
        window.print();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-retired-page"]) return;
  try {
    
const retiredLink = document.querySelector('[data-retired-page] a');
if (retiredLink && !window.Shopify?.designMode) window.location.replace(retiredLink.href);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-tds-library"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uc-tds-library')){
customElements.define('uc-tds-library',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const input=this.querySelector('input'),rows=[...this.querySelectorAll('[data-tds-product]')],empty=this.querySelector('[data-empty]');
this.querySelector('[data-search-panel]').hidden=false;
const update=()=>{const term=input.value.trim().toLocaleLowerCase();let count=0;rows.forEach(row=>{row.hidden=!row.dataset.search.includes(term);if(!row.hidden)count++;});empty.hidden=count>0;};
input.addEventListener('input',update);update();
}
});
}

  } catch(e) { console.error(e); }
})();
})();
